import { Participant } from '../../domain/models';

export interface ParticipantEntity {
  id: string;
  tournament_id: string;
  name: string;
  seed: number;
  user_id: string | null;
  created_at: string;
  updated_at: string;
}

// Mapper: de Entity (DB) a Model (Domain)
export const participantEntityToModel = (entity: ParticipantEntity, userEmail?: string): Participant => {
  return {
    id: entity.id,
    tournamentId: entity.tournament_id,
    name: entity.name,
    seed: entity.seed,
    userId: entity.user_id || undefined,
    userEmail,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
  };
};

// Mapper: de Model (Domain) a Entity (DB)
export const participantModelToEntity = (model: Partial<Participant>): Partial<ParticipantEntity> => {
  return {
    ...(model.tournamentId !== undefined && { tournament_id: model.tournamentId }),
    ...(model.name !== undefined && { name: model.name }),
    ...(model.seed !== undefined && { seed: model.seed }),
    ...(model.userId !== undefined && { user_id: model.userId || null }),
  };
};